import { action, withOptionalPayload, withoutPayload, withPayload } from '../../../utility/redux';
import { ItemList, ListParams } from '../../../types/main';
import { Product } from '../../../types/products';

// List actions
export const getProductListRequest = action(
  'GET_PRODUCT_LIST_REQUEST',
  withOptionalPayload<ListParams>(),
);

export const getProductListSuccess = action(
  'GET_PRODUCT_LIST_SUCCESS',
  withPayload<ItemList<Product>>(),
);

export const getProductListFail = action(
  'GET_PRODUCT_LIST_FAIL',
  withoutPayload,
);

export const setProductListDirty = action(
  'SET_PRODUCT_LIST_DIRTY',
  withPayload<boolean>(),
);

export const clearProductList = action(
  'CLEAR_PRODUCT_LIST',
  withoutPayload,
);
